/**
 * Static showcase games for the landing page.
 *
 * These are NOT loaded from Firebase. They exist so a first-time visitor always
 * sees what a Sparkforge game looks like, rather than an empty state or a
 * loading spinner that depends on the network, on auth, or on a game having
 * been approved by an admin.
 *
 * They are illustrative, not real records — nothing links through to a detail
 * page, and every card is labelled "Example" so it can't be mistaken for a
 * community submission.
 */
export const EXAMPLE_GAMES = [
  {
    id: 'example-lamplight',
    name: 'Lamplight',
    type: 'cooperative',
    tagline: 'Co-op deck-builder · 2–4 players · 45 min',
    description:
      'Two keepers hold a lighthouse through seven nights of rising storm. ' +
      'Spend fuel to keep the lamp lit, or hoard it and gamble on the weather ' +
      'turning. Every card you buy makes the next night harder.',
    accent: '#2b3a4a',
    icon: 'ra-torch'
  },
  {
    id: 'example-ogres',
    name: 'Ogres Gotta Eat',
    type: 'party',
    tagline: 'Push-your-luck · 3–6 players · 30 min',
    description:
      'You are an ogre. The village is a buffet. Roll to raid, press your luck ' +
      'for one more sheep, and try not to be the one still chewing when the ' +
      'pitchforks arrive.',
    accent: '#6b4423',
    icon: 'ra-meat'
  },
  {
    id: 'example-windtraders',
    name: 'The Windtraders',
    type: 'strategy',
    tagline: 'Route-building · 2–4 players · 60 min',
    description:
      'Chart trade routes across a shifting archipelago where the wind changes ' +
      'every round. Commit early for the short crossing, or wait and read the ' +
      'weather your rivals are betting against.',
    accent: '#1f5f6b',
    icon: 'ra-compass'
  }
];

/**
 * Inline SVG cover art, as a data URI.
 *
 * Deliberately generated rather than fetched: the whole point of these cards is
 * that they render with no network dependency at all. Firebase Storage URLs
 * would reintroduce exactly the failure this is meant to avoid.
 */
export function exampleCover(game) {
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="600" height="400" viewBox="0 0 600 400">
  <defs>
    <linearGradient id="g" x1="0" y1="0" x2="1" y2="1">
      <stop offset="0%" stop-color="${game.accent}"/>
      <stop offset="100%" stop-color="${game.accent}99"/>
    </linearGradient>
    <pattern id="p" width="28" height="28" patternUnits="userSpaceOnUse">
      <path d="M28 0H0v28" fill="none" stroke="#ffffff" stroke-opacity="0.12" stroke-width="1"/>
    </pattern>
  </defs>
  <rect width="600" height="400" fill="url(#g)"/>
  <rect width="600" height="400" fill="url(#p)"/>
  <rect x="26" y="26" width="548" height="348" rx="14" fill="none"
        stroke="#ffffff" stroke-opacity="0.35" stroke-width="2" stroke-dasharray="10 7"/>
  <text x="300" y="196" text-anchor="middle" fill="#ffffff" fill-opacity="0.95"
        font-family="Georgia, 'Times New Roman', serif" font-size="42" font-weight="bold">
    ${game.name.replace(/&/g, '&amp;').replace(/</g, '&lt;')}
  </text>
  <text x="300" y="232" text-anchor="middle" fill="#ffffff" fill-opacity="0.75"
        font-family="Helvetica, Arial, sans-serif" font-size="16" letter-spacing="2">
    EXAMPLE PROTOTYPE
  </text>
</svg>`;
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
}
